export const NAME = "core/autocomplete";
